import { fetchAuthSession } from 'aws-amplify/auth'; 
import { Evaluation, Level } from "./questionService";
import { deleteJson, getJson, postJson } from "./httpClient";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const projectService = {
    // Emula un método asíncrono
    save: async (project: Proyecto) => {
        try {
            const sesion = await fetchAuthSession();
            const token=sesion.tokens?.idToken;
            const data = await postJson<any>(`${API_BASE_URL}/save-project`, project, {
                "Authorization": `Bearer ${token}`,
            });
            
            //console.log("response:"+JSON.stringify(data));
            return data.project.idProyecto;
        } catch (error) {
            console.error("Error al guardar el proyecto:", error);
            throw error;
        }

        
    },
    listar: async ()=>{
        try {
            const sesion = await fetchAuthSession();
            const token = sesion.tokens?.idToken;
            const data = await getJson<ProjectListResponse>(`${API_BASE_URL}/project/list`, {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json",
            });
            return data.projects?? [] as Proyecto[];
        } catch (error) { 
            console.error("Error al listar evaluación:", error);
            throw error;
        }
    },
    getFinalEvaluationByProjectId: async (idProject: number):Promise<FinalEvaluation> => {
        try {
            const sesion = await fetchAuthSession();
            const token=sesion.tokens?.idToken;
            const data = await postJson<FinalEvaluationResponse>(`${API_BASE_URL}/project/final-evaluation`, idProject, {
                "Authorization": `Bearer ${token}`,
            });
            
            //console.log("response:"+JSON.stringify(resp));
            if(data.finalEvaluation)
                return data.finalEvaluation;
            throw new Error("No se encontro evaluacion");
        } catch (error) {
            console.error("Error al obtener evaluacion de proyecto:", error);
            throw error;
        }

        
    },
    deleteProject: async (id: number): Promise<DeleteProjectResponse> => {
        try {
            const sesion = await fetchAuthSession();
            const token = sesion.tokens?.idToken;
            const data = await deleteJson<DeleteProjectResponse>(`${API_BASE_URL}/delete-project`, { id }, {
                "Authorization": `Bearer ${token}`,
            });
            return data;
        } catch (error) {
            console.error("Error al eliminar el proyecto:", error);
            throw error;
        }
    }

}

export interface ProjectListResponse {
    message: string;
    error?: string;
    projects?: Proyecto[];
}
export interface FinalEvaluationResponse {
    message: string;
    error?: string;
    finalEvaluation?: FinalEvaluation;
    graph?: string;
}
export interface DeleteProjectResponse {
    message: string;
    id: number;
}


export interface FinalEvaluation {
    nombre: string;
    organizacion: string;
    tipoOrganizacion: string;
    tipoProyecto: string;
    nombreTipoProyecto: string;
    tipoSector: string;
    programa: string;
    nombreContacto: string;
    emailContacto: string;
    idProyecto: number;
    rut: string;
    fechaCreacion: Date;
    fechaActualizacion: Date;
    evaluacion: FinalLevel[];
}
export interface FinalLevel {
    id: number;
    idProject: number;
    rut: string;
    activa: boolean;
    fechaEvaluacion: Date | null;
    fechaCreacion: Date | null;
    fechaActualizacion: Date | null;
    crl: Level;
    brl: Level;
    trl: Level;
    iprl: Level;
    tmrl: Level;
    frl: Level;
}

export interface Proyecto {
    nombre: string;
    organizacion: string;
    tipoOrganizacion: string;
    tipoProyecto: string;
    nombreTipoProyecto: string;
    tipoSector: string;
    programa: string;
    nombreContacto: string;
    emailContacto: string;
    descripcion: string;
    idProyecto: number;
    idRegion: string;
    lideraMujer: boolean;
    imagenRadar:string|null;
    nuevaEvaluacion: Evaluation|null;
    financiamiento: Financiamiento[];
    evaluaciones: Evaluation[];
}

export interface Financiamiento {
    tipoFinanciamiento: string;
    codigoFinanciamiento: string;
}
